import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import styles from './GSTCalculator.module.css';

const GSTCalculator = () => {
    const [amount, setAmount] = useState('');
    const [gstRate, setGstRate] = useState(18);
    const [type, setType] = useState('exclusive'); // exclusive (add GST) or inclusive (remove GST)
    const [result, setResult] = useState(null);

    const calculateGST = () => {
        const principal = parseFloat(amount);
        if (isNaN(principal)) return;

        let gstAmount = 0;
        let totalAmount = 0;
        let originalAmount = 0;

        if (type === 'exclusive') {
            gstAmount = (principal * gstRate) / 100;
            totalAmount = principal + gstAmount;
            originalAmount = principal;
        } else {
            // Inclusive: Principal = Original + GST
            // Original = Principal / (1 + Rate/100)
            originalAmount = principal / (1 + gstRate / 100);
            gstAmount = principal - originalAmount;
            totalAmount = principal;
        }

        setResult({
            original: originalAmount,
            gst: gstAmount,
            total: totalAmount
        });
    };

    const handleReset = () => {
        setAmount('');
        setResult(null);
    };

    return (
        <>
            <Header />
            <div className={styles.pageWrapper}>
                <div className="container">
                    <div className={styles.calculatorCard}>
                        <h1 className={styles.title}>GST Calculator</h1>
                        <p className={styles.subtitle}>Compute GST amount easily for your business transactions.</p>

                        <div className={styles.formGroup}>
                            <label className={styles.label}>Amount (₹)</label>
                            <input
                                type="number"
                                className={styles.input}
                                value={amount}
                                onChange={(e) => setAmount(e.target.value)}
                                placeholder="Enter Amount"
                            />
                        </div>

                        <div className={styles.row}>
                            <div className={styles.formGroup}>
                                <label className={styles.label}>GST Rate (%)</label>
                                <select
                                    className={styles.select}
                                    value={gstRate}
                                    onChange={(e) => setGstRate(Number(e.target.value))}
                                >
                                    <option value={5}>5%</option>
                                    <option value={12}>12%</option>
                                    <option value={18}>18%</option>
                                    <option value={28}>28%</option>
                                </select>
                            </div>
                            <div className={styles.formGroup}>
                                <label className={styles.label}>Tax Type</label>
                                <select
                                    className={styles.select}
                                    value={type}
                                    onChange={(e) => setType(e.target.value)}
                                >
                                    <option value="exclusive">Exclusive (Add GST)</option>
                                    <option value="inclusive">Inclusive (Remove GST)</option>
                                </select>
                            </div>
                        </div>

                        <div className={styles.buttonGroup}>
                            <button className={styles.calcButton} onClick={calculateGST}>Calculate</button>
                            <button className={styles.resetButton} onClick={handleReset}>Reset</button>
                        </div>

                        {result && (
                            <div className={styles.resultBox}>
                                <div className={styles.resultRow}>
                                    <span>Net Amount:</span>
                                    <span>₹{result.original.toFixed(2)}</span>
                                </div>
                                <div className={styles.resultRow}>
                                    <span>GST Amount ({gstRate}%):</span>
                                    <span>₹{result.gst.toFixed(2)}</span>
                                </div>
                                <div className={`${styles.resultRow} ${styles.totalRow}`}>
                                    <span>Total Amount:</span>
                                    <span>₹{result.total.toFixed(2)}</span>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default GSTCalculator;
